<template>
    <div>
        <el-skeleton animated :rows="showRows" :loading="loading">
            <template #default>
                <el-table :data="truncatedData" :height="460" :border="true" :stripe="true">
                    <el-table-column style="text-wrap: nowrap !important" :min-width="100" :sortable="col.sortable" v-for="col in cols" :key="col.prop" :label="col.label" :prop="col.prop">
                    </el-table-column>
                    <slot></slot>
                </el-table>
                <el-pagination class="p-2" hide-on-single-page :total="pages" :default-current-page="1" :page-count="pages" @change="change">
                </el-pagination>
            </template>
        </el-skeleton>
    </div>
    
</template>

<script>
    export default {
        name: 'PersonalTable',
        props: {
            data: Array,
            cols: Array,
            rows: Number,
            height: Number,
            loading: Boolean
        },
        data() {
            return {
                page: 1,
                showRows: 8,
                sortProps: {
                    prop: null,
                    order: 'asc'
                }
            }
        },
        created() {
            //
        },
        methods: {
            change(val) {
                this.page = val
            },
            setSortProps(prop) {
                if (this.sortProps.prop == prop) {
                    if (this.sortProps.order == 'asc') { this.sortProps.order = 'desc'; return; }
                    else if (this.sortProps.order == 'desc') { this.sortProps.order = null; return; }
                }
                this.sortProps.prop = prop
                this.sortProps.order = 'asc'
            }
        },
        computed: {
            truncatedData() {
                let page = this.page - 1
                let len = this.data.length
                let show = this.showRows > 0 ? this.showRows:len
                return this.data.slice(show * page, show * page + show)
            },
            pages() {
                let div = this.data.length / this.showRows
                if (div - Math.floor(div) > 0) {
                    div += 1
                } 
                return Math.floor(div)
            }
        }
    }
</script>
